<template>
  <b-form>
    <div class="w-100 px-1">
      <b-row>
        <b-col cols="12" class="px-2 mb-1">
          <div class="d-flex" >
            <div class="mr-auto">
              <div>
                <label class="font-medium-5"
                    ><span class="text-black">Select Inventory</span>
                    (ทำการเลือกของรางวัลได้ทีละหนึ่งคลัง)</label
                >
                <v-select
                    v-model="formStatus.inventoryLabel"
                    class="v-select-filter bg-dropdown w-100"
                    :class="
                    formStatus.inventoryLabel
                        ? 'v-select-filter-selected'
                        : null
                    "
                    :clearable="false"
                    placeholder="- Select Inventory -"
                    :options="optionData.inventoryList"
                    @input="(option) => onSelectInventory(option.value)"
                />
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <div class="w-100 px-2">
        <b-row>
          <b-col cols="12" lg="6" sm="12" class="pl-0">
            <b-form-group
              :label="'Code Template Title'"
              label-for="code-template-title"
              label-class="font-medium-5"
            >
              <b-form-input
                id="code-template-title"
                required
                disabled
                v-model="formCodeDetail.title"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="6" sm="12">
            <b-form-group
              :label="'Code Template Ref'"
              label-for="code-template-ref"
              label-class="font-medium-5"
            >
              <b-form-input
                id="code-template-ref"
                required
                disabled
                v-model="formCodeDetail.template_ref"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <!-- <overlay-loading :loading="loading.tableData"> -->
        <div v-if="formStatus.inventoryId != null" class="w-100 px-2">
          <b-row>
            <b-col cols="12" lg="6" sm="12" class="pl-0">
              <b-form-group
                :label="'Privilege Name'"
                label-for="privilegename"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="privilege-name"
                  required
                  disabled
                  v-model="formEntryDetail.name"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6" sm="12">
              <b-form-group
                :label="'Privilege Reference'"
                label-for="privilege-reference"
                label-class="font-medium-5"
              >
                <b-form-input
                  id="privilege-reference"
                  required
                  disabled
                  v-model="formEntryDetail.reference"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" sm="12" class="pl-0">
              <b-row>
                <b-col cols="12" lg="10" sm="12">
                  <b-form-group
                    :label="'Removal Strategy'"
                    label-for="removal-strategy"
                    label-class="font-medium-5"
                  >
                    <v-select
                      v-model="formManageStock.removalStrategy"
                      class="select-format-container font-medium-5 bg-dropdown"
                      :class="[
                        formManageStock.removalStrategy
                          ? 'select-format-selected'
                          : null,
                        {},
                      ]"
                      :reduce="(option) => option.value"
                      :options="removalOptions"
                      required
                      :clearable="false"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" lg="4" sm="12">
              <label class="font-medium-5">Quantity ( Balance: {{qtyTotal}} )</label>
              <b-row>
                <b-col cols="12" lg="6" sm="12">
                  <b-form-group :label="'Export Code'" label-class="font-medium-5" />
                </b-col>
                <b-col cols="12" lg="6" sm="12">
                  <input-spin
                    :mode="qtyTotal == 0 ? 'disabled' : ''"
                    :numValue="quantityValue.Export"
                    :maxValue="qtyTotal"
                    :isInputDisabled="false"
                    @update-number="updateExport"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" lg="6" sm="12" class="pl-0">
              <img-zoom-content
                :width="'100%'"
                :height="'175px'"
                :imageUrl="formEntryDetail.image"
              />
            </b-col>
          </b-row>
          
        </div>
      <!-- </overlay-loading> -->
      <empty-content
        v-else
        :image="require('@/assets/images/artwork/folder.png')"
        :width-img="'300px'"
        :height-img="'auto'"
        :title="'Select Inventory'"
        class="empty-content-history-custom-height"
      />
    </div>
    <div class="mt-2 mb-2">
      <div class="d-flex justify-content-center">
        <save-button
          v-if="qtyTotal != 0" 
          @click.native="onSubmitExportCode"
          :btnLabel="'Export Code'"
          :loading="loading.form"
          class="ml-1"
        />
      </div>
    </div>
  </b-form>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import ImgZoomContent from "../../../../privilege-history/components/ImgZoomContent.vue"
import InputSpin from "@/views/components/input-spin/InputSpin.vue";
import Search from "@/views/components/search/Search.vue";
import vSelect from "vue-select";
import CardNoItem from "@core/components/card-no-item/CardNoItem.vue";
import EmptyContent from "@/views/components/empty-content/EmptyContent.vue";
import useExportCode from "../../hooks/useExportCode.js";

export default {
  components: {
    BaseModal,
    vSelect,
    Search,
    CardNoItem,
    EmptyContent,
    ImgZoomContent,
    InputSpin
  },
  props: {
    templateId: { type: [Number, String], default: 1 },
    templateData: { type: [Object, Array], default: null },
  },
  setup(props) {
    const {
      loading,
      optionData,
      formStatus,
      formEntryDetail,
      formCodeDetail,
      qtyTotal,
      quantityValue,
      formManageStock,
      removalOptions,
      updateExport,
      onSelectInventory,
      onSubmitExportCode
    } = useExportCode(props);

    return {
      loading,
      optionData,
      formStatus,
      formEntryDetail,
      formCodeDetail,
      qtyTotal,
      quantityValue,
      formManageStock,
      removalOptions,
      updateExport,
      onSelectInventory,
      onSubmitExportCode
    };
  },
}
</script>

<style scoped>
@import '~@/assets/css/pages/default-static-table.css';
@import '~@/assets/css/override-styles/v-select.css';
@import '~@/assets/css/override-styles/dynamic-fields.css';
@import '~@/assets/css/pages/privilege/privilege-code-template/code-template-exportcode.css';
</style>